import { render, staticRenderFns } from "./TournamentCreate.vue?vue&type=template&id=19459b5a&scoped=true"
import script from "./TournamentCreate.vue?vue&type=script&lang=js"
export * from "./TournamentCreate.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./TournamentCreate.vue?vue&type=style&index=1&id=19459b5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19459b5a",
  null
  
)

export default component.exports